export const addZero = (num) => {
    num = parseInt(num);
    return (num >= 0 && num < 10) ? "0" + num : num + "";
};

export const getTempToWindChill = (t, v) => {
    var v3 = Math.pow(v * 3.6, 0.16);
    return Math.round(13.12 + 0.6215 * t - (11.37 * v3) + 0.3965 * v3 * t, 0);
};
